import { twMerge } from 'tailwind-merge';
import { DialogContent, Dialog as MuiDialog } from '@mui/material';

import { Icon } from '../icons';

import { DialogProps } from './types';

export const Dialog = ({
  open,
  title,
  onClose,
  actions,
  children,
  onExited,
  maxWidth = 456,
}: DialogProps) => (
  <MuiDialog
    open={open}
    scroll="paper"
    onClose={onClose}
    className="z-3100"
    slotProps={{
      transition: {
        onExited,
      },
      paper: {
        sx: {
          maxWidth,
          width: '100%',
        },
      },
      backdrop: {
        sx: (theme) => ({
          background: `${theme.palette.black.primary}CC`,
        }),
      },
    }}
  >
    {title && (
      <div className="relative px-4 py-3 md:px-6 md:pt-5 md:pb-4">
        <h3 className="pr-6 text-lg leading-7">{title}</h3>
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-2 flex cursor-pointer items-start md:right-3"
        >
          <Icon.Close />
        </button>
      </div>
    )}
    <DialogContent
      className={twMerge('p-4 md:p-6', actions && 'pb-0!', title && 'pt-0!')}
    >
      {children}
    </DialogContent>
    {actions && (
      <div className="flex gap-4 p-4 *:flex-1 md:gap-6 md:p-6">{actions}</div>
    )}
  </MuiDialog>
);
